<template>
  <v-dialog v-model="model" max-width="600px" persistent>
    <v-card>
      <v-container>
      <v-form ref="form" lazy-validation>
        <v-card-title>
          <span class="headline">{{$t('AddContentCategory.ContentCategories')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-row>
                    <v-col cols="12" sm="9">
                        <v-text-field
                          ref="categoryName"
                          v-model="categoryName"
                          :label="$t('AddContentCategory.Name')"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-btn color="primary" class="float-right mb-10" @click="addCategory">
                        {{$t('AddContentCategory.Add')}}
                      </v-btn>
                    </v-col>
                </v-row>
              </v-col>
                <v-col cols="12">
                  <v-list>
                  <v-list-item class="p-0" v-for="category in categoryList" :key="category.id">
                    <v-list-item-content>
                      <v-list-item-title v-if="!category.changed">{{category.name}}</v-list-item-title>

                      <v-text-field v-if="category.changed"
                          v-model="category.name"
                          :label="$t('AddContentCategory.Name')+'*'"
                          :rules="rules.categoryName"
                          counter="70"
                          required>
                      </v-text-field>
                    </v-list-item-content>

                    <v-list-item-action style="flex-direction: inherit">
                      <v-icon @click="updateCategory(category)">mdi-pen</v-icon>&nbsp;&nbsp;
                      <v-icon @click="removeCategory(category)">mdi-delete</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="close">
             {{$t('GeneralTranslations.Cancel')}}
          </v-btn>

          <v-btn color="red darken-1" text @click="saveCategories" :loading="loading">
            {{$t('GeneralTranslations.Save')}}
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-container>
      
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from "vuex";
  import { v4 as uuidv4 } from "uuid";
  import { ValidationRules } from "@/utils/validation-rules"
  import * as firebase from "firebase/app";
  
  export default {
    components: {},
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
          categories: (state) => state.contentLibraryModule.contentCategories,
          currentFacility: state => state.authModule.currentFacility
      }),
      categoryList(){
        return this.newCategories.concat(this.allCategories)
      },
      rules() {
        return {
          categoryName: [ValidationRules.min(2), ValidationRules.max(70)],
        };
      },
      model: {
        get() {
          return this.value;
        },
        set() {
          this.close()
        }
      }
    },
    mounted(){
      this.$store.dispatch("getContentCategories")
    },
    data() {
      return {
        categoryName:"",
        allCategories: [],
        newCategories: [],
        removeCategories: [],
        loading: false
      }
    },
    watch:{
      categories(){
        this.allCategories = this.categories
      }
    },
    methods: {
      close() {
        this.newCategories = []
        this.removeCategories = []
        this.categoryName = ''
        this.loading = false
        this.$emit("close");
      },
       addCategory() {
        if(this.categoryName.length){
          this.newCategories.push({id:uuidv4(),name: this.categoryName});
          this.categoryName = '';
        }
      },
      updateCategory(category){
        category.changed = true
        this.$forceUpdate(); 
      },
  
      removeCategory(category) {
        this.removeCategories.push(category);
        this.allCategories = this.allCategories.filter(x=>x.id !== category.id)
        this.newCategories = this.newCategories.filter(x=>x.id !== category.id)
      },
     
      saveCategories() {
        this.loading = true
        const promises = []

        //add
        if(this.newCategories.length){
          const promise = this.$store.dispatch("addContentCategories", this.newCategories.map((x)=> {delete x.id; return x;}))
          promises.push(promise)
        }

        //delete
        if(this.removeCategories.length){
          const promise = this.$store.dispatch("deleteContentCategories", this.removeCategories)
          promises.push(promise)
        }

        //update
        const changedCategories = this.categories.filter(x=>x.changed && x.id)
        if(changedCategories.length >0){
          const promise = this.$store.dispatch("updateContentCategories", changedCategories)
          promises.push(promise)
        }

        console.log('promises:' + promises.length)

        Promise.all(promises).then(async()=>{
         console.log('done')
         await this.$store.dispatch("getContentCategories");
         await this.$store.dispatch('getContentItems');
         this.close();
        });
      }
    }
  };
</script>
